// GAVION product-training: the « Produit » course texts, English twin of trainingProduct.fr.ts. Same keys, faithful
// translation of the questions approved by the owner 2026-11-02.
export const productMissionsEn = {
  product_pitch: {
    title: "Gala in 30 seconds",
    desc: "%{count} questions to pitch Gala and Gavion.",
  },
  product_pricing: {
    title: "Packages and prices",
    desc: "%{count} questions about the packages, with the catalog prices.",
  },
  product_addons: {
    title: "Add-ons and terms",
    desc: "%{count} questions about the add-ons and the terms.",
  },
  product_fit: {
    title: "The right package",
    desc: "%{count} situations: which package to offer?",
  },
  product_objections: {
    title: "Objections",
    desc: "%{count} objections and the right answer.",
  },
  product_availability: {
    title: 'Available or "Soon"',
    desc: "%{count} features: live today, or coming?",
  },
  product_how_gala: {
    title: "How Gala answers",
    desc: "%{count} questions about a call with Gala.",
  },
  product_setup: {
    title: "The setup",
    desc: "%{count} questions about getting set up.",
  },
  product_integrations: {
    title: "The integrations",
    desc: "%{count} questions about the connected tools.",
  },
  product_client_gets: {
    title: "What the customer gets",
    desc: "%{count} questions about what the customer sees and receives.",
  },
  product_admin_assistant: {
    title: "Administrative assistant",
    desc: "%{count} questions about the administrative assistant.",
  },
};

export const trainingProductEn = {
  course: { label: "Course", phone: "Phone selling", product: "Product" },
  tracks: {
    sell: {
      title: "Sell Gavion",
      subtitle: "What a seller needs to know to pitch and sell Gala.",
    },
    deep: {
      title: "Gavion in depth",
      subtitle:
        "The product in detail: the call, the setup, the integrations, the assistant.",
      locked_hint: 'Pass all of "Sell Gavion" to unlock this course.',
    },
  },
  catalog_unavailable: "Catalog unavailable: try again later.",
  read_context: "Read in All about Gavion",
  availability: {
    available: "Available",
    soon: "Soon",
    explanation:
      'Never present a "Soon" feature as available. Safe wording: "QuickBooks, Stripe and crew dispatching are coming soon."',
  },
  q: {
    product_pitch: {
      q1: {
        prompt: "What is Gala?",
        a: "A bilingual AI receptionist and administrative assistant for service and construction businesses",
        b: "A call center with human receptionists",
        c: "Accounting software for contractors",
        d: 'A phone menu: "press 1"',
        explanation:
          "Gala answers every call, 24/7, in Quebec French and in English.",
      },
      q2: {
        prompt: "Which customers is Gala designed for?",
        a: "Small and mid-sized service and construction businesses in Quebec (plumbing, HVAC, electrical, roofing, snow removal…)",
        b: "Large banks",
        c: "Medical clinics",
        d: "Online stores",
        explanation:
          "The website does not present Gala as suited to the healthcare sector.",
      },
      q3: {
        prompt: "What problem does Gala solve first?",
        a: "Missed calls: a missed call is a customer who calls the next company",
        b: "Unpaid invoices",
        c: "Hiring employees",
        d: "Inventory management",
        explanation:
          '"A missed call is a customer who calls the next company on their list."',
      },
      q4: {
        prompt: "What are Gala's two roles?",
        a: "Receptionist (during the call) and administrative assistant (the office work after the call)",
        b: "Receptionist and accountant",
        c: "Saleswoman and dispatcher",
        d: "Receptionist and technician",
        explanation:
          "The administrative assistant includes the full receptionist.",
      },
      q5: {
        prompt: "Which languages does Gala answer the phone in?",
        a: "Quebec French and English, detected automatically, on the same number (44 languages supported)",
        b: "French only",
        c: "English; French costs extra",
        d: "Two numbers, one per language",
        explanation: '"One number, two languages, no surcharge."',
      },
      q6: {
        prompt:
          'A prospect says: "So it replaces my receptionist?" What do you answer?',
        a: "No: Gala handles what nobody does (evening calls, follow-ups, quotes that are waiting)",
        b: "Yes, you save her salary",
        c: "Yes, after a one-month trial",
        d: "It depends on the package",
        explanation: 'Replacing staff is "not the argument we make".',
      },
      q7: {
        prompt: "Where is the data hosted?",
        a: "In Canada; the application server is in Quebec, in Beauharnois",
        b: "In the United States",
        c: "In Europe",
        d: "On the customer's computer",
        explanation:
          "Data is never sold and never used to train third-party models.",
      },
      q8: {
        prompt: "Who founded Gavion, and where?",
        a: "Antoine, Vincent and Martin Gagnon, in Montreal, in 2026",
        b: "An American firm from Silicon Valley",
        c: "A Toronto group in 2015",
        d: "A French franchise",
        explanation: "Gavion inc. is a Montreal voice-AI company.",
      },
    },
    product_addons: {
      c1: {
        prompt: "How much does installation cost?",
        a: "$0, on every package",
        b: "$199",
        c: "$499",
        d: "One month of the package",
        explanation:
          "Onboarding support is available as an optional, à la carte add-on.",
      },
      c2: {
        prompt: "What discount does annual billing give?",
        a: "15%, paid in a single payment at the start of the period",
        b: "10%",
        c: "2 free months",
        d: "No discount",
        explanation: "",
      },
      c3: {
        prompt: "A customer wants to cancel. What applies?",
        a: "Cancel any time, no fees; the package stays active until the end of the paid period",
        b: "3-month penalty",
        c: "One-year minimum contract",
        d: "Pro-rated refund",
        explanation:
          "Never promise or mention a refund, even for an annual package.",
      },
      c4: {
        prompt: 'What is a "user"?',
        a: "A person with named access to the platform (the customers who call are not users)",
        b: "Every customer who calls",
        c: "Every phone number",
        d: "Every technician on the road",
        explanation:
          "A voice agent, on the other hand, is a distinct phone personality, with its own number and script.",
      },
      c5: {
        prompt: "The customer goes over their minutes. What happens?",
        a: "The extra minutes are billed at the package's published rate ($0.33 to $0.42), rounded up to the next minute",
        b: "Gala stops answering",
        c: "They must switch packages right away",
        d: "It's free",
        explanation:
          "More than 1,000 minutes a month: a tailored setup is available on request.",
      },
      c6: {
        prompt: "Can the customer try before buying?",
        a: "They can call the demo line or ask Gala to call them back; there is no free trial and no money-back guarantee",
        b: "Yes, a 30-day free trial",
        c: "Yes, satisfaction guaranteed or your money back",
        d: "No, there is no demo",
        explanation: "The line where Gala answers live: +1 (514) 534-1298.",
      },
    },
    product_fit: {
      q1: {
        prompt: "A plumber works alone and misses calls while on a job site.",
        a: "Receptionist — Essential",
        b: "Assistant — Enterprise",
        c: "Receptionist — Enterprise",
        d: "Assistant — Advanced",
        explanation:
          '"For self-employed workers and small teams." 250 minutes, 3 users.',
      },
      q2: {
        prompt:
          "A 5-person roofing company with a steady call volume just wants someone to answer.",
        a: "Receptionist — Advanced",
        b: "Receptionist — Essential",
        c: "Assistant — Essential",
        d: "Assistant — Enterprise",
        explanation:
          '"For growing teams with a steady call volume." 500 minutes, 5 users.',
      },
      q3: {
        prompt: "A landscaper also wants to send photo quotes to customers.",
        a: "An Administrative Assistant plan",
        b: "Receptionist — Enterprise",
        c: "Receptionist — Essential",
        d: "No package does it",
        explanation:
          "Photo quoting is a function of the administrative assistant.",
      },
      q4: {
        prompt:
          "An HVAC company with several crews and more than 900 call minutes a month.",
        a: "Receptionist — Enterprise (1,000 minutes, 7 users)",
        b: "Receptionist — Essential",
        c: "Receptionist — Advanced",
        d: "Assistant — Essential",
        explanation: '"For busy, multi-crew operations."',
      },
      q5: {
        prompt:
          "A customer has two brands, each with its own number and greeting.",
        a: "They need two voice agents (included depending on the package, or $10/month more)",
        b: "Two full subscriptions",
        c: "Not possible with Gala",
        d: "One more user",
        explanation: "Essential: 1 voice agent, Advanced: 2, Enterprise: 3.",
      },
      q6: {
        prompt:
          "A customer asks whether 24/7 emergencies are included in the entry package.",
        a: "Yes: every Receptionist package has the same features, emergencies and transfers included",
        b: "Only in Enterprise",
        c: "Only in Advanced and Enterprise",
        d: "It's a paid add-on",
        explanation: "The packages differ in minutes, users and voice agents.",
      },
    },
    product_objections: {
      q1: {
        prompt: '"My customers don\'t like talking to a robot."',
        a: "A natural voice, in real time, with no keypad menu; the current alternative is often voicemail",
        b: '"Gala will never say she\'s an AI"',
        c: '"You can turn the AI off"',
        d: '"She\'s actually a human"',
        explanation: "Never say that Gala hides being an AI when she is asked.",
      },
      q2: {
        prompt: '"What if she doesn\'t know the answer?"',
        a: "She never makes things up: she rephrases once, then transfers or takes a detailed message with a priority callback",
        b: "She guesses the best answer",
        c: "She hangs up",
        d: "She puts the caller on hold",
        explanation: '"Better a transfer than an invented answer."',
      },
      q3: {
        prompt: '"She\'ll give out prices any which way."',
        a: "No firm price over the phone: only the amounts you approve",
        b: "She calculates the final price herself",
        c: "She gives the lowest price",
        d: "She never talks about money",
        explanation: "Quotes stay within your approved ranges.",
      },
      q4: {
        prompt: '"I\'m not technical."',
        a: "Nothing to install, no hardware; guided steps and support when needed",
        b: "An on-site technician is required",
        c: "You have to buy an IP phone",
        d: "You have to code the agent",
        explanation: "",
      },
      q5: {
        prompt: '"Do I have to change my number?"',
        a: "No, just a simple call forward; customers call the same number",
        b: "Yes, Gala provides a new number",
        c: "Yes, for the second language",
        d: "Only for the entry package",
        explanation: "",
      },
      q6: {
        prompt: '"I\'m too small for this."',
        a: "That's where the gap is the biggest: a single job over $129 recovered pays for the month",
        b: '"Come back when you have a team"',
        c: '"Take the Enterprise package"',
        d: '"We guarantee $2,800 a month"',
        explanation:
          "Never guarantee a specific result: the calculator gives an estimate.",
      },
      q7: {
        prompt: '"How long does it take to set up?"',
        a: "In just a few days",
        b: "24 hours guaranteed",
        c: "Six weeks",
        d: "It depends on the technician",
        explanation: "This is the only wording allowed: no other timeframe.",
      },
      q8: {
        prompt: '"ChatGPT can do that."',
        a: "A chat assistant doesn't answer the phone at 7 p.m., doesn't know your prices and can't access your calendar",
        b: '"ChatGPT is worse than we are"',
        c: '"Gala is ChatGPT"',
        d: '"You\'re right, use ChatGPT"',
        explanation: "Stay factual, never disparage.",
      },
    },
    product_how_gala: {
      q1: {
        prompt:
          "What does Gala do when several customers call at the same time?",
        a: "She answers them all: no busy line, no one put on hold",
        b: "She puts the others on hold",
        c: "The second caller gets voicemail",
        d: "She calls back later",
        explanation: "",
      },
      q2: {
        prompt: "A customer calls with an emergency (a burst pipe at 2 a.m.).",
        a: "She asks the emergency questions, transfers to the on-call line with a text to the team; if nobody answers, a detailed message and a priority callback",
        b: "She books an appointment in 3 days",
        c: "She says to call back tomorrow",
        d: "She gives a firm price",
        explanation: "",
      },
      q3: {
        prompt: "How does Gala qualify a prospect?",
        a: "With your own qualification questions, and she sorts emergencies according to your rules",
        b: "With a fixed Gavion questionnaire",
        c: "She doesn't qualify",
        d: "She asks for a credit card",
        explanation: "",
      },
      q4: {
        prompt: "A returning customer calls.",
        a: "Gala recognizes them from your CRM; a written summary of the call goes to the dashboard",
        b: "She asks for everything again",
        c: "She always transfers them",
        d: "She keeps no record",
        explanation: "",
      },
      q5: {
        prompt: "What does Gala never do on the phone?",
        a: "Give a firm price, promise unverified availability, or say anything that isn't in the knowledge base",
        b: "Book an appointment",
        c: "Transfer a call",
        d: "Send a confirmation text",
        explanation: "These are the guardrails.",
      },
      q6: {
        prompt: "Does Gala also answer texts and emails?",
        a: "Yes, 24/7, by call, text and email",
        b: "Calls only",
        c: "Emails only",
        d: "Business hours only",
        explanation: "",
      },
    },
    product_setup: {
      q1: {
        prompt: "What is the first step of the setup?",
        a: 'Create the receptionist (a first "mini Gala")',
        b: "Buy hardware",
        c: "Change your number",
        d: "Sign a one-year contract",
        explanation:
          "Then: show the business, connect the phone, test, enrich.",
      },
      q2: {
        prompt: "What do you need to teach Gala about the business?",
        a: "Services, prices, territories, emergency rules and what she is allowed to say",
        b: "Nothing, she guesses",
        c: "Only the address",
        d: "Employees' passwords",
        explanation: "The calendar and the customer list are connected too.",
      },
      q3: {
        prompt: "What sets the pace of the setup?",
        a: "The size of the business: number of services, employees and rules",
        b: "The package chosen",
        c: "The weather",
        d: "The number of calls",
        explanation:
          "Name the person who fills in and validates the knowledge base.",
      },
      q4: {
        prompt: "Does Gala depend on the office's Internet?",
        a: "No, she is hosted: nothing depends on the office connection",
        b: "Yes, fiber is required",
        c: "Yes, an on-site server",
        d: "Only for texts",
        explanation: "",
      },
      q5: {
        prompt: "What do we recommend after launch?",
        a: "Listen to the first month's calls, then a 30-minute review every quarter",
        b: "Nothing",
        c: "Reconfigure everything every week",
        d: "Change packages every month",
        explanation: "",
      },
      q6: {
        prompt: "What support does the customer get?",
        a: "A bilingual team based in Quebec, 24/7 support",
        b: "An English-language forum",
        c: "Email only, 5 business days",
        d: "No support",
        explanation: "",
      },
    },
    product_integrations: {
      q1: {
        prompt: "Which calendars does Gala use today?",
        a: "Google Calendar and Outlook (Microsoft 365)",
        b: "Google only",
        c: "Only a Gavion calendar",
        d: "None",
        explanation: "",
      },
      q2: {
        prompt: "How do you connect the current business number?",
        a: "By call forwarding, no hardware",
        b: "By porting it to Gavion",
        c: "With a box",
        d: "It's not possible",
        explanation: "",
      },
      q3: {
        prompt: "The customer uses a tool that isn't on the list.",
        a: "We can usually connect it through an API or webhook; we confirm before signing",
        b: "It's impossible",
        c: "We promise it works",
        d: "We tell them to change tools",
        explanation: '"Name your tools before signing."',
      },
      q4: {
        prompt: "Is QuickBooks connected today?",
        a: "No, it's coming soon",
        b: "Yes, on every package",
        c: "Yes, on Enterprise",
        d: "Yes, as an add-on",
        explanation: "",
      },
      q5: {
        prompt: "How does the customer list get into Gala?",
        a: "Through the customer's CRM, or we import it",
        b: "It has to be retyped",
        c: "Gala finds it on Google",
        d: "She doesn't need one",
        explanation: "",
      },
      q6: {
        prompt:
          "A customer already on Jobber mainly wants a native integration.",
        a: "We stay honest: the website itself says a competitor like Fulltime.ai may be a better fit",
        b: "We say Gala already integrates with Jobber",
        c: "We disparage Jobber",
        d: "We quote the competitor's prices",
        explanation: "Stay factual, never quote competitors' prices.",
      },
    },
    product_client_gets: {
      q1: {
        prompt: "After every call, the customer finds…",
        a: "A written summary in the dashboard",
        b: "Nothing",
        c: "Only the audio recording",
        d: "An invoice",
        explanation: "",
      },
      q2: {
        prompt: "What does the dashboard show?",
        a: "Calls, transcripts, bookings, usage and analytics, on computer or phone",
        b: "Invoices only",
        c: "Minutes only",
        d: "Nothing, everything is by email",
        explanation: "",
      },
      q3: {
        prompt: "How does the team know there is an emergency?",
        a: "The call is transferred to the on-call line, with a text to the team",
        b: "By mail",
        c: "The next morning",
        d: "It doesn't know",
        explanation: "",
      },
      q4: {
        prompt:
          "What does the end customer receive after booking an appointment?",
        a: "Confirmations and reminders by text and email",
        b: "Nothing",
        c: "A call from a human",
        d: "An invoice",
        explanation: "",
      },
      q5: {
        prompt: "Call recordings, if enabled…",
        a: "Are stored in Canada and deleted after 90 days",
        b: "Are kept forever",
        c: "Are sold",
        d: "Are in the United States",
        explanation: "Live audio has zero retention at the voice provider.",
      },
      q6: {
        prompt: "What does the customer receive about blocked calls?",
        a: "A daily summary of the spam, solicitations and robocalls blocked",
        b: "Nothing",
        c: "A call from each robot",
        d: "An invoice for each blocked call",
        explanation: "",
      },
    },
    product_admin_assistant: {
      q1: {
        prompt: "Does the administrative assistant include the receptionist?",
        a: "Yes, the full receptionist",
        b: "No, you need both subscriptions",
        c: "Daytime calls only",
        d: "Emails only",
        explanation: "",
      },
      q2: {
        prompt: "How does photo quoting work?",
        a: "The customer sends a photo or an address; AI vision and satellite measurement produce a preliminary quote in a few minutes, within your ranges",
        b: "A technician always comes out",
        c: "Gala gives a firm price",
        d: "The customer fills out a paper form",
        explanation:
          "The firm price is still confirmed by your team; an insufficient photo is flagged for a visit.",
      },
      q3: {
        prompt: "How many quotes are included?",
        a: "5 / month (Essential), 15 / month (Advanced), unlimited (Enterprise)",
        b: "None",
        c: "1 a month on every package",
        d: "Unlimited on every package",
        explanation: "Additional quotes from $8.",
      },
      q4: {
        prompt: "What does the assistant's 360° CRM do?",
        a: "Every call, message, job and payment enriches the customer record",
        b: "It replaces accounting",
        c: "It sends newsletters",
        d: "It runs payroll",
        explanation: "",
      },
      q5: {
        prompt: "Which documents does the assistant produce?",
        a: "Contracts, work orders, before-and-after photo reports, job completion certificates",
        b: "Tax returns",
        c: "Pay stubs",
        d: "Building permits",
        explanation:
          "Plus a consent register, an audit log, export and the right to erasure.",
      },
      q6: {
        prompt: "What analytics does the assistant provide?",
        a: "Revenue per technician, conversion by source, average invoice per service, seasonal predictions",
        b: "None",
        c: "Only the number of calls",
        d: "The weather",
        explanation: "",
      },
    },
    product_availability: {
      q1: {
        prompt:
          "Booking an appointment in Google Calendar or Outlook during the call",
      },
      q2: { prompt: "QuickBooks sync" },
      q3: { prompt: "Stripe deposits and payments" },
      q4: { prompt: "Outbound calls (callbacks, quote follow-ups)" },
      q5: { prompt: "Crew scheduling and dispatching" },
      q6: { prompt: "Spam and robocall filtering, with a daily summary" },
      q7: { prompt: "Photo quoting (administrative assistant)" },
      q8: { prompt: "Several calls at once, no busy line" },
    },
  },
};
